import { createContext, useContext } from "react";
import type { PredictionFormValues } from "@/features/prediction/model/form";
import type { PredictionRunState } from "@/features/prediction/model/reducer";
import type { PredictionRequest } from "@/features/prediction/model/types";
import type { PredictionHistoryRecord } from "@/features/prediction/model/predictionHistory";

export interface PredictionContextValue {
  run: PredictionRunState;
  draft: PredictionRequest | null;
  latestRecord: PredictionHistoryRecord | null;
  startPrediction: (
    request: PredictionRequest,
    review: PredictionFormValues,
  ) => Promise<void>;
  cancelPrediction: () => void;
  resetRun: () => void;
  setDraft: (request: PredictionRequest | null) => void;
  showHistoryRecord: (record: PredictionHistoryRecord) => void;
}

/**
 * Context 实例与 Provider 组件分离，避免开发环境热更新组件模块时改变实例身份。
 */
export const PredictionContext =
  createContext<PredictionContextValue | null>(null);

export function usePrediction(): PredictionContextValue {
  const value = useContext(PredictionContext);
  if (!value) {
    throw new Error("usePrediction must be used within PredictionProvider");
  }
  return value;
}
